// @flow
import React from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: theme.palette.greyScale[5],
    minHeight: 76,
    paddingLeft: 24,
    display: 'flex',
    alignItems: 'center',
  },
  subtitle: {
    color: theme.palette.greyScale[2],
    padding: '8px 0px 0px 24px',
  },
}));

const Title = () => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.header}>
        <Typography
          variant="h5"
        >
          Add your Account
        </Typography>
        {/* <Typography variant="subtitle1" className={classes.subtitle}>
          Authenticating through Plaid
        </Typography> */}
      </div>
    </>
  );
};

export default Title;
